module.exports = __webpack_public_path__ + "img/9788952749222.e3a6a756.jpg";